import { connect } from 'react-redux';

import * as CliApp from 'app/entities/CliApp';
import * as DeveloperActions from 'app/developer-v3/Actions';
import * as EnvironmentVariable from 'app/entities/EnvironmentVariable';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import hocify from 'app/common/components/hocify';
import {
  currentAppEntity,
  lifecycleHasFailed,
  lifecycleHasFinished,
  lifecycleHasStarted,
  versionEnvironmentVariables,
} from 'app/developer-v3/selectors';

import Environment from './Environment';

import type { StringMap } from 'app/common/types';

const mapStateToProps = state => {
  const appEntity = currentAppEntity(state);
  const envVars = versionEnvironmentVariables(state);

  const isLoadingApp = CliApp.selectors.isLoading(appEntity);
  const isLoadingEnvVars = EnvironmentVariable.selectors.all.isLoading(state);
  const isSaving =
    lifecycleHasStarted(state) &&
    !(lifecycleHasFinished(state) || lifecycleHasFailed(state));

  return {
    isLoading: isLoadingApp || isLoadingEnvVars,
    isSaving,
    initialEnvVars: envVars,
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  onLoad() {
    const { id, version } = props.params;
    dispatch([
      DeveloperActions.loadAppAndVersion(id, version),
      DeveloperActions.loadEnvironmentForVersion(),
    ]);
  },
  async saveEnv(env: StringMap) {
    await dispatch(DeveloperActions.batchUpdateEnvironmentVariables(env));
    dispatch(EnvironmentVariable.actions.resetAndLoadCollection());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(Environment));
